import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { FaLaptopCode, FaServer, FaTools, FaToolbox } from "react-icons/fa";
import skills from "../data/skills.json";

function Skills() {

    const iconMap = {
       FaServer: FaServer,
       FaLaptopCode: FaLaptopCode,
       FaTools: FaTools,
       FaToolbox: FaToolbox
    };

    const ref = useRef(null);
    const isInView = useInView(ref, { once: true });

    return (
        <section id="skills" ref={ref} className="px-6 py-20 bg-white-900 text-black">
            <h2 className="text-3xl font-bold text-center mb-12 relative text-black">
              Skills
              <div className="w-24 h-1 bg-[#964b00] mx-auto mt-2"></div>
            </h2>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
                {skills.map((skill,index) => {
                    const IconComponent = iconMap[skill.icon];

                    return (
                        <motion.div
                          key={index}
                          className="bg-white rounded-lg shadow-md p-6 hover:shadow-xl transition"
                          whileHover={{ scale: 1.03 }}
                        >
                          <div className="flex items-center gap-3 mb-4">
                            {IconComponent && (
                               <IconComponent className="text-2xl text-[#964b00]" />
                            )}
                            <h3 className="text-xl font-semibold">{skill.title}</h3>
                          </div>
                          <ul className="space-y-4">
                            {skill.skills.map((s,i) => (
                                <li key={i}>
                                  <div className="flex justify-between mb-1 text-sm font-medium text-gray-700">
                                    <span>{s.name}</span>
                                    <span>{s.level}%</span>
                                  </div>
                                  <div className="w-full bg-gray-200 rounded-full h-3">
                                    <motion.div
                                      className="bg-[#987654] h-3 rounded-full"
                                      initial={{ width: 0 }}
                                      animate={{ width: isInView ? `${s.level}%` : 0 }}
                                      transition={{ duration: 1, delay: i * 0.2 }}
                                    />
                                  </div>
                                </li>
                            ))}
                          </ul>
                      </motion.div>
                    )

                })}
            </div>
        </section>
    )
}

export default Skills;